/**
 * pageAskRegistry — lightweight event bus that lets any page register a
 * context-specific "Ask" panel into the global ChatWidget button column.
 *
 * Usage (in a page component):
 *   import { usePageAsk } from "@/lib/pageAskRegistry";
 *   usePageAsk({ title: "Ask history", icon: "history", open, setOpen });
 *
 * ChatWidget listens for the registration event and renders the button.
 * When the page unmounts it fires a clear event so the button disappears.
 */

export const PAGE_ASK_EVENT = "pageAsk:register";
export const PAGE_ASK_CLEAR = "pageAsk:clear";

/**
 * Register a page-level Ask button into the ChatWidget column.
 *
 * @param {object} opts
 *   title    string   — button label, e.g. "Ask history"
 *   color    string   — tailwind bg class, e.g. "bg-violet-600"
 *   onOpen   function — called when ChatWidget button is clicked
 */
export function registerPageAsk(opts) {
  window.dispatchEvent(new CustomEvent(PAGE_ASK_EVENT, { detail: opts }));
}

export function clearPageAsk() {
  window.dispatchEvent(new CustomEvent(PAGE_ASK_CLEAR));
}
